import React from 'react';
import { createRoot } from 'react-dom/client';
import { RecoveryPointsSearchResult } from '../main-app/components/RecoveryPointsSearchResult';

document.addEventListener('DOMContentLoaded', () => {
  const resultContainer = document.querySelector('.vv-search-results');

  const root = createRoot(resultContainer);

  const latitude = resultContainer.getAttribute('data-latitude');
  const longitude = resultContainer.getAttribute('data-longitude');
  const date = resultContainer.getAttribute('data-date');
  const title = resultContainer.getAttribute('data-title');

  const locationIds = resultContainer.getAttribute('data-location-ids');
  const city = resultContainer.getAttribute('data-city');
  const department = resultContainer.getAttribute('data-department');
  const center = resultContainer.getAttribute('data-center');
  const parsedCenter = center ? JSON.parse(center) : null;

  const filterButton = document.querySelector(
    '.vv-map-container__mobile-control-bar__button-filter'
  );
  const mapButton = document.querySelector('.vv-map-container__mobile-control-bar__button-map');

  const isCityPage = locationIds && city && department;
  const isSearchResultsPage = latitude && longitude;

  if (!isCityPage && !isSearchResultsPage) {
    return;
  }

  root.render(
    <RecoveryPointsSearchResult
      latitude={latitude}
      longitude={longitude}
      date={date}
      title={title}
      locationIds={locationIds}
      city={city}
      department={department}
      filterButton={filterButton}
      mapButton={mapButton}
      isCityPage={!!isCityPage}
      cityCenter={parsedCenter}
    />
  );
});
